import { render, staticRenderFns } from "./BioTexts.vue?vue&type=template&id=7406d51f&"
import script from "./BioTexts.vue?vue&type=script&lang=js&"
export * from "./BioTexts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports